import { OnInit, Component } from '@angular/core';
import { ModalComponent } from '../../modal/modal.component';

@Component({
    templateUrl: './create-folder.component.html',
    standalone: false
})
export class CreateFolderComponent implements OnInit {
  public name: string;

  constructor(public modal: ModalComponent) {}

  ngOnInit(): void {
    this.modal.closeButton = false;
  }

  createFolder(): void {
    this.modal.close(this.name);
  }

  cancel() {
    this.modal.close();
  }
}
